import gql from 'graphql-tag';

const fragment = gql`
    fragment cartData on Cart {
        id
        checkoutUrl
        totalQuantity
        buyerIdentity {
            customer {
                firstName
                lastName
                email
            }
        }
        discountCodes {
            applicable
            code
        }
        lines(first: 50) {
            edges {
                node {
                    id
                    quantity
                    cost {
                        subtotalAmount {
                            amount
                            currencyCode
                        }
                        totalAmount {
                            currencyCode
                            amount
                        }
                    }
                    discountAllocations {
                        ... on CartAutomaticDiscountAllocation {
                            title
                            discountedAmount {
                                amount
                                currencyCode
                            }
                        }
                        ... on CartCodeDiscountAllocation {
                            code
                            discountedAmount {
                                amount
                                currencyCode
                            }
                        }
                    }
                    merchandise {
                        ... on ProductVariant {
                            id
                            sku
                            title
                            quantityAvailable
                            image {
                                url
                            }
                            price {
                                currencyCode
                                amount
                            }
                            compareAtPrice {
                                amount
                            }
                            product {
                                id
                                handle
                                productType
                                title
                                vendor
                                productSubType: metafield(namespace: "custom", key: "sub_type") {
                                    __typename
                                    value
                                    type
                                }
                                tags
                            }
                        }
                    }
                }
            }
        }
        cost {
            checkoutChargeAmount {
                amount
                currencyCode
            }
            totalAmount {
                amount
                currencyCode
            }
            subtotalAmount {
                amount
                currencyCode
            }
        }
        deliveryGroups(first: 10) {
            edges {
                node {
                    id
                    selectedDeliveryOption {
                        title
                        description
                        estimatedCost {
                            amount
                        }
                    }
                }
            }
        }
    }
`;

export { fragment };
